import React from 'react';
import parse, { domToReact } from 'html-react-parser';

const BlacklinePost = ({ title, body }) => {
  const options = {
    replace: ({ name, children }) => {
      if (!name) {
        return;
      }

      if (name === 'span') {
        return <p>{domToReact(children, options)}</p>;
      }
    },
  };

  return (
    <div className="blackline">
      <h2>{title}</h2>
      <div className="normal-text">{parse(body, options)}</div>
    </div>
  );
};

export default BlacklinePost;
